import { render, staticRenderFns } from "./UploadBlock.vue?vue&type=template&id=e40b7576&scoped=true&"
import script from "./UploadBlock.vue?vue&type=script&lang=ts&"
export * from "./UploadBlock.vue?vue&type=script&lang=ts&"
import style0 from "./UploadBlock.vue?vue&type=style&index=0&id=e40b7576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40b7576",
  null
  
)

export default component.exports